import { NgModule } from '@angular/core';
import { Platform } from '@ionic/angular';
import { provideFirebaseApp, initializeApp } from '@angular/fire/app';
import { provideAppCheck, initializeAppCheck, ReCaptchaEnterpriseProvider } from '@angular/fire/app-check';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouteReuseStrategy } from '@angular/router';
import { provideHttpClient, HttpClient } from '@angular/common/http';
import { IonicModule, IonicRouteStrategy } from '@ionic/angular';
import { SplashScreen } from '@ionic-native/splash-screen/ngx';
import { StatusBar } from '@ionic-native/status-bar/ngx';
import { ScreenOrientation } from '@ionic-native/screen-orientation/ngx';

// import { FileTransfer } from '@awesome-cordova-plugins/file-transfer/ngx';

// added for Fire v 7

//import { provideAuth, getAuth } from '@angular/fire/auth';
import { provideDatabase, getDatabase } from '@angular/fire/database';
import { provideFirestore, getFirestore } from '@angular/fire/firestore';
import { provideFunctions, getFunctions } from '@angular/fire/functions';
import { provideStorage, getStorage, StorageModule } from '@angular/fire/storage';
import { FIREBASE_OPTIONS } from '@angular/fire/compat';

import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';

import { environment } from '@env/environment';

import { SharedModule } from '@shared/shared.module';
import { StoreModule } from '@ngrx/store';
import { WebBluetoothModule } from '@manekinekko/angular-web-bluetooth';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { WorkerService } from '@shared/worker/worker.service';
import { ServiceWorkerModule } from '@angular/service-worker';

import { IKeyStorage } from '@shared/crypto/key-manager';
import { keyStorageFactory } from '@shared/crypto/key-storage.factory';
import { KeyStorageWebService } from '@shared/services/key-storage-web.service';

export function createTranslateLoader(http: HttpClient) {
  // console.log(http);
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}

export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  // console.log(http);
  return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [AppComponent],
  bootstrap: [AppComponent],
  imports: [
    WebBluetoothModule.forRoot({ enableTracing: true }),
    BrowserModule,
    IonicModule,
    BrowserAnimationsModule,
    IonicModule.forRoot({ animated: false, mode: 'md' }),
    StorageModule,

    TranslateModule.forRoot({
      defaultLanguage: 'sv',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    AppRoutingModule,
    SharedModule,
    StoreModule.forRoot({}),
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: true,
      // Register the ServiceWorker as soon as the application is stable
      // or after 30 seconds (whichever comes first).
      registrationStrategy: 'registerWhenStable:30000',
    }),
  ],
  providers: [
    // 1. Firebase app FIRST
    provideFirebaseApp(() => initializeApp(environment.firebase)),

    // 2. App Check SECOND
    provideAppCheck(() => {
      if (!environment.production) {
        (self as any).FIREBASE_APPCHECK_DEBUG_TOKEN = true;
      }
      return initializeAppCheck(undefined, {
        provider: new ReCaptchaEnterpriseProvider(environment.recaptchaSiteKey),
        isTokenAutoRefreshEnabled: true,
      });
    }),

    // 3. Storage THIRD — right after App Check
    provideStorage(() => getStorage()),

    // 4. Functions FOURTH
    provideFunctions(() => getFunctions(undefined, 'europe-west1')),

    // 5. Everything else after
    { provide: FIREBASE_OPTIONS, useValue: environment.firebase },
    provideHttpClient(),
    WorkerService,
    StatusBar,
    SplashScreen,
    KeyStorageWebService,
    {
      provide: 'IKeyStorage',
      useFactory: keyStorageFactory,
      deps: [Platform],
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    ScreenOrientation,
  ],
})
export class AppModule {}
